import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

export type ContinueShoppingClickedEvent =
  TrackingEvent<"Continue Shopping Clicked">;

export async function trackContinueShoppingClickedEvent(): TrackingEventResponse {
  return await trackEvent("Continue Shopping Clicked", {
    withRequestSource: true,
  });
}
